import { connect, useDispatch } from 'react-redux';
import * as $ from 'jquery';
import Moment from 'moment';
import { orderEdit, orderCreate } from '../../../redux/actions/order/orderActions';
import { appointmentLoad } from '../../../redux/actions/appointmentActions';
import { staffsLoad } from '../../../redux/actions/staffActions';
import { claimFormReset } from '../../../redux/actions/order/claimFormActions';
import { tabChange } from '../../../itrust_common/redux/actions/otherActions';
import Alert from '../../../itrust_common/components/Alert';
import { patientReportsLoad } from '../../../itrust_common/redux/actions/settingActions/patientReportActions';
import { onBoardingTourInfoReset } from '../../../redux/actions/onBoardingActions';
import { visionInsuranceClaimFormReset } from '../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction';
import { storeStaffsLoad } from '../../../redux/actions/currentStoreActions';

function CreateOrderButton(props) {
  const { children, patientId, appointmentId, currentUser, activeTourType, store, patient, patientName } = props
  let staffId = currentUser.id
  const dispatch = useDispatch()

  const createParams = { status: 'unfinished', order_date: Moment(new Date()).format("YYYY/MM/DD"), patient_id: patientId, staff_id: staffId, appointment_id: appointmentId }

  const handleOrderSubmit = (data) => {
    let localStorageStoreId = localStorage.getItem('StoreID')
    if (activeTourType === 'create_order') {
      dispatch(onBoardingTourInfoReset(activeTourType))
    }

    if (localStorageStoreId == null) {
      Alert.warning("Please select store from top dropdown.")
    }
    else {
      Alert.confirm(
        <div className="d-flex">You’re creating a new order for <strong className="px-2">{patientName ?? patient.name}</strong> at <strong className="px-2">{store.name}</strong>.</div>,
        (response) => {
          if (response) {
            if (localStorageStoreId && localStorageStoreId !== 'null') {
              // list all staffs despite from their designation
              dispatch(storeStaffsLoad(localStorageStoreId, { rpp: 1000, filter: {} }))
            }
            dispatch(claimFormReset())
            dispatch(visionInsuranceClaimFormReset())
            dispatch(tabChange({ order: 1 }))
            dispatch(orderCreate(data, { include: '*' })).then((response) => {
              let res = response.value.data.order
              dispatch(orderEdit(res.id));
              dispatch(patientReportsLoad({ patient_id: res.patient_attributes.id, staff_id: res.staff_id, store_id: res.store_attributes.id, filter: { category: "invoice" } }))
              dispatch(staffsLoad({ rpp: 9999, filter: { selected_store: store.id } }))
              //Load appointment if order created from appointment
              if (appointmentId) {
                dispatch(appointmentLoad(appointmentId, { include: ['patient', 'staff', 'procedures', 'examination', 'order'] }))
              }
              $('#orderForm-modal').modal('show');
            })
          }
        }
      )
    }
  }

  return (
    <span className="pointer" onClick={() => handleOrderSubmit(createParams)}>
      {children}
    </span>
  )
}


function mapStateToProps(state) {
  const { patient, currentStore, auth } = state;
  return {
    patient: patient.patient,
    store: currentStore.store,
    currentUser: auth.user
  };
}

export default connect(mapStateToProps)(CreateOrderButton);